import { useEffect, useState } from "react";

import { localDateKey } from "../utils/localDate";

// Today's local date key, kept current: the app can stay open (or suspended
// on iOS) across midnight, and "today's meals" must roll over when it does.
export const useToday = () => {
  const [today, setToday] = useState(() => localDateKey());

  useEffect(() => {
    const refresh = () => setToday(localDateKey());
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("focus", refresh);
    const timer = setInterval(refresh, 60_000);
    return () => {
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("focus", refresh);
      clearInterval(timer);
    };
  }, []);

  return today;
};
